import lobbyModule from "./lobby"
import newGame from "./newGameModalController"
import deleteBoard from "./deleteBoardModalController"
import 'angular-bootstrap-toggle/dist/angular-bootstrap-toggle'
import 'angular-ui-notification'

angular.module('lobby', ['ui.toggle', 'ui.bootstrap', 'ui-notification'])
  .config([
    'NotificationProvider',
    function(notificationProvider){
      notificationProvider.setOptions({
        positionX: 'center'
      });
    }
  ]);
newGame();
deleteBoard();
lobbyModule();
